module.exports = __webpack_public_path__ + "static/media/security_trading_dark.1dc781bd.svg";